import { merchantConstants } from "../constants/merchantConstants";

const initialState = {
  sendingMerchant: false,
  requestingDeleteLocation: false,
  merchantDetails: {},
  addMerchantResponse: [],
  merchantType: [],
  addMerchantLocationResponse: {},
  deletedmerchantresponse: {},
  merchantLocationDetails: {},
  deletedLocationresponse: {},
  error: {},
  errmsg: "",
  loading:false,
  mrechantResponse: {},
  updatedMerchant: {},
  sendingMerchantDetails: false,
  sendingDefaultTax:false,
  defaultTaxresponse: {}
};

export default function merchantReducer(state = initialState, action) {
  switch (action.type) {
    case merchantConstants.ADD_MERCHANT_REQUEST:
      return {
        ...state,
        sendingMerchant: true
      };
    case merchantConstants.ADD_MERCHANT_SUCCESS:
      return {
        ...state,
        mrechantResponse: action.data,
        addMerchantResponse: action.data.data
      };
    case merchantConstants.ADD_MERCHANT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case merchantConstants.ADD_MERCHANT_LOCATION_REQUEST:
      return {
        ...state,
        sendingMerchant: true
      };
    case merchantConstants.ADD_MERCHANT_LOCATION_SUCCESS:
      return {
        ...state,
        sendingMerchant: false,
        addMerchantLocationResponse: action.data
      };
    case merchantConstants.ADD_MERCHANT_LOCATION_FAILURE:
      return {
        ...state,
        sendingMerchant: false,
        error: action.error
      };
    case merchantConstants.GET_MERCHANT_DETAILS_REQUEST:
      return {
        sendingMerchantDetails: true
      };
    case merchantConstants.GET_MERCHANT_DETAILS_SUCCESS:
      return {
        ...state,
        sendingMerchantDetails: false,
        merchantDetails: action.data.data
      };
    case merchantConstants.GET_MERCHANT_DETAILS_FAILURE:
      return {
        ...state,
        sendingMerchantDetails: false,
        error: action.error
      };
    case merchantConstants.GET_MERCHANT_LIST_REQUEST:
      return {
        sending: true
      };
    case merchantConstants.GET_MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        merchantList: action.data.data
      };
    case merchantConstants.GET_MERCHANT_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case merchantConstants.GET_MERCHANT_TYPE_LIST_REQUEST:
      return {
        sending: true
      };
    case merchantConstants.GET_MERCHANT_TYPE_LIST_SUCCESS:
      return {
        ...state,
        merchantType: action.data.data
      };
    case merchantConstants.GET_MERCHANT_TYPE_LIST_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case merchantConstants.DELETE_MERCHANT_REQUEST:
      return {
        ...state,
        sending: true
      };
    case merchantConstants.DELETE_MERCHANT_SUCCESS:
      return {
        ...state,
        deletedmerchantresponse: action.data
      };
    case merchantConstants.DELETE_MERCHANT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case merchantConstants.GET_MERCHANT_LOCATION_DETAILS_REQUEST:
      return {
        sending: true
      };
    case merchantConstants.GET_MERCHANT_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        merchantLocationDetails: action.data
      };
    case merchantConstants.GET_MERCHANT_LOCATION_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case merchantConstants.UPDATE_MERCHANT_REQUEST:
      return {
        ...state,
        sendingMerchant: true
      };
    case merchantConstants.UPDATE_MERCHANT_SUCCESS:
      return {
        ...state,
        loading:false,
        updatedMerchant: action.data,
        merchantDetails: action.data.data,
      };
    case merchantConstants.UPDATE_MERCHANT_FAILURE:
      return {
        ...state,
        sendingMerchant: false,
        loading:false,
        error: action.error
      };
    case merchantConstants.DELETE_MERCHANT_LOCATION_REQUEST:
      return {
        ...state,
        requestingDeleteLocation: true
      };
    case merchantConstants.DELETE_MERCHANT_LOCATION_SUCCESS:
      return {
        ...state,
        requestingDeleteLocation: false,
        deletedLocationresponse: action.data
      };
    case merchantConstants.DELETE_MERCHANT_LOCATION_FAILURE:
      return {
        ...state,
        requestingDeleteLocation: false,
        deleteLocationError: action.error
      };

      case merchantConstants.GET_DEFAULT_TAX_REQUEST:
      return {
        sendingDefaultTax: true
      };
    case merchantConstants.GET_DEFAULT_TAX_SUCCESS:
      return {
        ...state,
        sendingDefaultTax: false,
        defaultTaxresponse: action.data
      };
    case merchantConstants.GET_DEFAULT_TAX_FAILURE:
      return {
        ...state,
        sendingDefaultTax: false,
        error: action.error
      };  
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/merchantReducer.js